import React from 'react'; 
import '../Artists/Zen-Frescos/Zen-Frescos.css'; 
 

function ArtServiceMandarin() {
    return (
      <>
           
          <div className="Art-Service">
          <form method="get" action="#/art-service">
            <button id="the-button" type='btn'>English</button> 
          </form> 
            <h1 className="artist">藝術服務</h1> 
            <hr /> 

            <br /> 

            <p id="art-paragraph-other">
            美国龙画廊擁有強大的藝術顧問團隊。 顧問具有國際各個藝術領域相關的高級資質。 他們盡力推荐一些最有才華的潛在藝術家在美國龙画廊展示他們的作品。
            此外，我們的團隊幫助藝術家與世界上最好的畫廊和拍賣場建立合作機會，如蘇富比、佳士得、巴塞爾藝術展、私人收藏家和博物館。 
            這個專業的團隊將通過展覽、研討會、跨國駐留創作和拍賣來幫助展示藝術家的才華。 我們使用與全球合作夥伴網絡相關的資源來幫助分發高質量的藝術品。 
            American Dragon以開放、包容、多元化的態度，吸引了各行各業才華橫溢、富有創造力的藝術家。 請聯繫我們以了解有關我們服務的更多信息。  
            </p>

            <br /> 

            <p id="art-paragraph-other">
            电话：917-886-1701 
            </p> 

            <p id="art-paragraph-other">
            电子邮件：info@americandragonfineart.com 
            </p> 

            <br />
            <hr /> 
            <br /> 
             
            <h1 className="artist-uh">中國藝術之旅</h1> 

            <h5 id="caption-uh">
            中国艺术之旅 
            </h5>
            <p id="art-paragraph-bottom">
            抵达后，旅游代表将在机场与您会面，然后护送您入住酒店。
            </p>
            <p id="art-paragraph-bottom-mobile">
            抵达后，旅游代表将在机场与您会面，然后护送您入住酒店。
            </p>
            <br /> 

            <h5 id="caption-uh">
            第二天：
            </h5>
            <p id="art-paragraph-bottom">
            在北京画廊为您展览举办开幕酒会或自由活动日 
            </p>
            <p id="art-paragraph-bottom-mobile">
            在北京画廊为您展览举办开幕酒会或自由活动日 
              </p>
            <ul id="list">
                <li id="bullet">
                1. 您在北京画廊开幕式上的个人展览或团体展览（前往中国之前签订展览合同）
                </li>
                <li id="bullet">
                2. 参观北京艺术区  
                </li>
                <li id="bullet">
                3. 在北京享受免费的一天。独自探索中国的首都。 
                </li> 
              </ul> 
            <p id="art-paragraph-bottom">
            在北京过夜。 
            </p>
            <p id="art-paragraph-bottom-mobile">
            在北京过夜。
              </p>
            <br /> 

            <h5 id="caption-uh">
            第三天：北京
            </h5>
            <p id="art-paragraph-other">
            您对北京的探索始于参观世界上最大的公共广场之一天安门广场，然后进入紫禁城故宫。紫禁城，也被正式称为故宫博物院，最初是由明朝的第三位皇帝永乐皇帝建造的，
            曾有24位皇帝曾经在此居住。这座宫殿建于1406年至1420年之间，但经过无数次的烧毁，重建，拆除和翻新，所以您今天可以看到的大多数建筑都可以追溯到1700年代。
            然后，参观珍珠工厂，以获取一些有关新鲜珍珠的知识。
            </p>
            <br /> 

            <h5 id="caption-uh">
            第四天：北京  
            </h5>
            <p id="art-paragraph-other">
            在通往长城的路上，您将在玉器博物馆停留，以学习玉器的历史。在中国，玉的发音为“玉”，在中国至少有四千年的历史。当他们创建复杂的设计时，
            请观察熟练的技术人员。然后，沿着风景秀丽的乡村和山脉驱车前往中国最著名的古迹长城。参观人数较少且较原始的居庸Pass关，
            并尽量避免使用其他最容易到达且因此最拥挤的区域。长城蜿蜒穿过中国北部山脉，从黄海到戈壁沙漠-超过3500英里！
            </p>
            <br /> 

            <h5 id="caption-uh">
            第五天：北京 
            </h5>
            <p id="art-paragraph-bottom">
            取回画廊作品收到销售作品的钱或自由活动 在北京享受免费的一天。独自探索中国的首都。在北京过夜。 
            </p> 
            <p id="art-paragraph-bottom-mobile">
            取回画廊作品收到销售作品的钱或自由活动 在北京享受免费的一天。独自探索中国的首都。在北京过夜。
            </p> 
            <br /> 

            <h5 id="caption-uh">
            第六天：北京/杭州 
            </h5>
            <p id="art-paragraph-other">
            今天乘飞机飞往杭州。中国美术学院在这个城市，很多画廊和喜欢艺术品的收藏家。去画廊准备您今天晚上作品展览开幕式酒会，或者自由活动 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            第七天： 
            </h5>
            <p id="art-paragraph-other">
            杭州被认为是中国的茶叶之都，因此，如果不去当地的茶馆旅行，对杭州的访问就不会完成。特别参观位于西湖公园腹地的梅家坞茶庄的茶馆，
            那里被认为是中国最重要的龙井茶产品之一。享受自然环境和美丽的乡村风光，同时进一步了解其特殊的茶文化以及如何欣赏龙井茶的鲜香和香气。
            在茶馆里，学习如何制作龙井茶，包括采摘，油炸和品尝茶叶。之后，乘船在另一个被联合国教科文组织列为世界遗产的西湖上乘船游览，
            这揭示了杭州柳树垂柳的岛屿的空灵之美。

            </p> 
            <br /> 

            <h5 id="caption-uh">
            第八天：
            </h5>
            <p id="art-paragraph-other">
            在杭州市自由活动或者乘车2-3小时去艺术家驻访基地（自费）在美丽的山和水还有天然的树林怀抱中，参观艺术家免费的工作室，
            您也可以申请未来免费工作室，在这美丽的大自然中画画和写生。晚上住在杭州或者艺术家驻访基地的酒店。 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            第九天：杭州/上海 
            </h5>
            <p id="art-paragraph-other">
            早晨，开车前往上海，然后参观著名的外滩。上海被黄浦江分为东西两部分。在东部可以看到现代的大型高层建筑，而在西部可以看到传统的欧式建筑。
            外滩是一个有五个街区的海滨长廊，有许多上海的银行和贸易行。中国以丝绸闻名，所以可以肯定的是，我们将带您到绢纺厂。然后护送您到酒店休息。 
            </p> 
            <br /> 
            
            <h5 id="caption-uh">
            第十天：上海 
            </h5>
            <p id="art-paragraph-other">
            早餐后，您将参观豫园，它是上海必游景点中的经典园林。它的历史可以追溯到明朝（1368-1644），由一位名叫潘云端的政府官员拥有。 
            Yu的中文意思是愉悦和满足，这个花园是专为Pan的父母建造的，是让他们在晚年享受宁静快乐时光的地方。后来到城huang庙的过程，
            它被称为“老街”。它指的是一个古老的街区，拥有100多家寺庙，饭店和商店。该区域在“古老的中国”环境中包含狭窄的车道和小广场。 
            </p> 
            <br /> 

            <h5 id="caption-uh">
            第11天：上海出发  
            </h5>
            <p id="art-paragraph-bottom">
            早餐后，您将被送往机场乘飞机回家。 
            </p> 
            <p id="art-paragraph-bottom-mobile">
            早餐后，您将被送往机场乘飞机回家。 
            </p> 
            <br /> 

            <br /> 

            <p id="art-paragraph-poem">
            *上面的行程让您参考，或者您有其它想法，我们可以满足您的愿望，帮助你和作品得到更多人的关注，并且最好的成功。* 
            </p>

          </div>
        </> 
    );
  }
  
  export default ArtServiceMandarin;